import { render, staticRenderFns } from "./ChipBase.vue?vue&type=template&id=a29a07ce&scoped=true"
import script from "./ChipBase.vue?vue&type=script&setup=true&lang=js"
export * from "./ChipBase.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ChipBase.vue?vue&type=style&index=0&id=a29a07ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a29a07ce",
  null
  
)

export default component.exports